import React from 'react';

const BankForm = ({ formData, handleChange }) => {
  const labelWidth = 250; // px
  const paddingOffset = 60; // px: gap between label and edge of screen

  return (
    <div style={{ padding: '5px' }}>
      <h2 style={{ marginBottom: '20px' }}>Subscriber’s Wire Transfer Instructions:</h2>
      <>
        {[
          { label: "Bank Name:", name: "bankName" },
          { label: "Bank Address:", name: "bankLocation" },
          { label: "ABA Routing Number (U.S. Banks):", name: "abaRoutingNumber" },
          { label: "Swift Code (non-U.S. Banks):", name: "swiftCode" },
          { label: "Account Name:", name: "accountName" },
          { label: "Account Number:", name: "accountNumber" },
          { label: "Reference:", name: "reference" },
        ].map(({ label, name }) => (
          <div
            key={name}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '12px',
            }}
          >
            <label
              htmlFor={name}
              style={{
                minWidth: `${labelWidth}px`,
                marginRight: '10px',
                textAlign: 'left',
                whiteSpace: 'normal',
                lineHeight: '1.2',
                paddingTop: '4px',
              }}
            >
              {label}
            </label>
            <input
              id={name}
              type="text"
              name={name}
              value={formData[name]}
              onChange={handleChange}
              required={["accountNumber", "abaRoutingNumber"].includes(name)}
              style={{
                padding: '6px 10px',
                width: `calc(100vw - ${labelWidth + paddingOffset}px)`,
                maxWidth: '600px',
                border: '1px solid #ccc',
                borderRadius: '4px',
              }}
            />
          </div>
        ))}
      </>
    </div>
  );
};

export default BankForm;
